<template>
  <div style="height: 100%">
    <top-header @changeCollapse="handleChangeCollapse"></top-header>
    <div class="wrapper">
      <main-aside :isCollapse="collapse"></main-aside>
      <div class="content-wrap">
        <div class="content">
          <transition name="move" mode="out-in">
            <keep-alive>
              <router-view></router-view>
            </keep-alive>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MainAside from "./Aside.vue";
import TopHeader from "./Header.vue";
export default {
  name: "Home",
  components: {
    MainAside,
    TopHeader,
  },
  data() {
    return {
      collapse: false,
    };
  },
  created() {
  },
  methods: {
    handleChangeCollapse() {
      this.collapse = !this.collapse;
      if (this.collapse) {
        document.getElementsByClassName("aside")[0].style.width = 64 + "px";
      } else {
        document.getElementsByClassName("aside")[0].style.width = 200 + "px";
      }
    },
  },
};
</script>
<style>
</style>
